// extracted by mini-css-extract-plugin
module.exports = {"badge_wrapper":"EffectsBanner_badge_wrapper__FxKjK","subtitle":"EffectsBanner_subtitle__AFP0V","text_wrapper":"EffectsBanner_text_wrapper__Uh3GP"};